import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {  contentModel } from 'src/app/models/contentModel';
import { page } from 'src/app/models/page';
import { rootModel } from 'src/app/models/rootModel';
import { DataService } from 'src/app/Services/data.service';


@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.css']
})
export class PagesComponent implements OnInit {

  contentModel:contentModel = new contentModel() ;

  rootmodel:rootModel = new rootModel();

  page:page = new page();

  constructor(private dataServices:DataService,
     private route:ActivatedRoute
     ) { 


     }

  ngOnInit(): void {

     this.route.paramMap.subscribe(params=>{

       this.rootmodel.page_id = params.get("category");

      this.getPages(this.rootmodel);

    })


  }

    getContent(rootmodel)
    {

      console.log(rootmodel);
      this.contentModel.content = new page();   

       this.dataServices.getContent(rootmodel).subscribe(p=>{    
          this.contentModel = p;     
       });
    }

    getPages(rootmodel)
    {
    this.contentModel.content = new page();   

       this.dataServices.getPages(rootmodel).subscribe(p=>{    
          this.page = p;  
       });
    }
    
}
